<template>
  <!-- <div v-if="this.role != 'admin'">
    <vs-breadcrumb>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Setting"
          >Manage Work</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Work Management</li>
    </vs-breadcrumb>
    <vs-row vs-type="flex" vs-justify="space-between" vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #def1ff, #def1ff);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h4 class="text-info" style="font-weight: 400">Open Tasks</h4>
            <vs-spacer /><vs-spacer /><vs-spacer /><vs-icon
              icon="sync_alt"
              size="30px"
              color="#189AFA"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center text-info font-weight-bold">{{ lt }}</h4>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #dbf7d7, #dbf7d7);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h4 style="font-weight: 400; color: #32c040">Completed Tasks</h4>
            <vs-spacer /><vs-spacer /><vs-icon
              icon="done"
              size="30px"
              color="#32c040"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center font-weight-bold" style="color: #32c040">
            {{ ct }}
          </h4>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #ffeedb, #ffeedb);
            border-radius: 15px;
          "
        >
          <vs-row>
            <h4 class="text-warning" style="font-weight: 400">On Going</h4>
            <vs-spacer /><vs-icon
              icon="snooze"
              size="30px"
              color="warning"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center text-warning font-weight-bold">{{ og }}</h4>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #ffdfdb, #ffdfdb);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h4 class="text-danger" style="font-weight: 400">Time Spent</h4>
            <vs-spacer /><vs-icon
              icon="query_builder"
              size="30px"
              color="danger"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center text-danger font-weight-bold">{{ ts }} hr</h4>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col>
        <vs-row id="center">
          <h4 class="ml-2 mt-1 mb-3" style="color: #111111">
            Assignment of Open Work Orders
          </h4>
          <vs-spacer />
        </vs-row>
        <vs-card style="border-radius: 20px">
          <vs-tabs alignment="right" color="#555555">
            <vs-tab icon="list" label="List View">
              <Workview
                :tempdata="getWororderUser"
                :filterPriority="filterPriority"
                :filterAsset="filterAssetUser"
                :filterResponse="filterResponse"
                :filterActive="filterActive"
                :filterAssignedTo="filterAssignedTo"
                :primeTable="tempdata"
                :selectedWO="selectedWO"
                :workerlist="workerlist"
                :headerFilter="headerFilter"
                :workerwork="workerwork"
                :users="users"
                :header="header"
                :arrFilter="arrFilter"
                :role="role"
              />
            </vs-tab>
            <vs-tab icon="event_note" label="Calendar View">
              <CalendarView
                :users2="users2"
                :filterPriority="filterPriority"
                :filterResponse="filterResponse"
                :filterAsset="filterAssetAll"
                :filterActive="filterActive"
                :filterAssignedTo="filterAssignedTo"
                :attributes="attributes"
                :tempdata="getWororderUser"
                :selectedWO="selectedWO"
                :workerlist="workerlist"
                :headerFilter="headerFilter"
                :workerwork="workerwork"
                :users="users"
                :header="header"
                :role="role"
              />
            </vs-tab>
          </vs-tabs> </vs-card></vs-col
    ></vs-row>
  </div> -->
  <div>
    <!-- {{ roleAccount }} -->
    <vs-breadcrumb>
      <li>
        <a aria-current="page" style="color: rgba(0, 0, 0, 0.4)" title="Setting"
          >Manage Work</a
        ><span class="vs-breadcrum--separator">/</span>
      </li>
      <li aria-current="page" class="textSuccess">Work Management</li>
    </vs-breadcrumb>

    <vs-row vs-type="flex" vs-justify="space-between" vs-w="12">
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #def1ff, #def1ff);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h4 class="text-info" style="font-weight: 400">Open Tasks</h4>
            <vs-spacer /><vs-spacer /><vs-spacer /><vs-icon
              icon="sync_alt"
              size="30px"
              color="#189AFA"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center text-info font-weight-bold">{{ lt }}</h4>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #dbf7d7, #dbf7d7);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h4 style="font-weight: 400; color: #32c040">Completed Tasks</h4>
            <vs-spacer /><vs-spacer /><vs-icon
              icon="done"
              size="30px"
              color="#32c040"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center font-weight-bold" style="color: #32c040">
            {{ ct }}
          </h4>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #ffeedb, #ffeedb);
            border-radius: 15px;
          "
        >
          <vs-row>
            <h4 class="text-warning" style="font-weight: 400">On Going</h4>
            <vs-spacer /><vs-icon
              icon="snooze"
              size="30px"
              color="warning"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center text-warning font-weight-bold">{{ og }}</h4>
        </vs-card>
      </vs-col>
      <vs-col vs-type="flex" vs-justify="center" vs-w="3" vs-sm="6" vs-xs="12">
        <vs-card
          style="
            background: linear-gradient(45deg, #ffdfdb, #ffdfdb);
            border-radius: 15px;
          "
        >
          <vs-row
            ><h4 class="text-danger" style="font-weight: 400">Time Spent</h4>
            <vs-spacer /><vs-icon
              icon="query_builder"
              size="30px"
              color="danger"
            ></vs-icon
          ></vs-row>
          <br />
          <h4 class="text-center text-danger font-weight-bold">{{ ts }} hr</h4>
        </vs-card>
      </vs-col>
    </vs-row>
    <vs-row>
      <vs-col>
        <vs-row id="center">
          <h4 class="ml-1 mt-1 mb-1" style="color: #111111">
            Assignment of Open Work Orders
          </h4>
          <vs-spacer />
          <vs-tooltip text="Add New Work Order" position="top">
            <h6>
              <vs-button
                class="mt-1 mb-1"
                color="success"
                v-if="this.roleAccount == 'admin'"
                style="border-radius: 20px"
                size="sm"
                icon="add"
                v-b-modal.modal-newWork
                type="filled"
                >New Work Order</vs-button
              >
            </h6>
          </vs-tooltip>
        </vs-row>
        <br />
        <vs-card style="border-radius: 20px">
          <vs-tabs alignment="right" color="#555555">
            <vs-tab icon="list" label="List View">
              <Workview
                :tempdata="tempdata"
                :filterPriority="filterPriority"
                :filterResponse="filterResponse"
                :filterActive="filterActive"
                :filterAsset="filterAssetAll"
                :filterAssignedTo="filterAssignedTo"
                :primeTable="tempdata"
                :selectedWO="selectedWO"
                :workerlist="workerlist"
                :headerFilter="headerFilter"
                :workerwork="workerwork"
                :users="users"
                :header="header"
                :arrFilter="arrFilter"
                :role="roleAccount"
              />
            </vs-tab>
            <vs-tab icon="event_note" label="Calendar View">
              <CalendarView
                :users2="users2"
                :filterPriority="filterPriority"
                :filterResponse="filterResponse"
                :filterAsset="filterAssetAll"
                :filterActive="filterActive"
                :filterAssignedTo="filterAssignedTo"
                :attributes="attributes"
                :tempdata="tempdata"
                :selectedWO="selectedWO"
                :workerlist="workerlist"
                :headerFilter="headerFilter"
                :workerwork="workerwork"
                :users="users"
                :header="header"
                :role="roleAccount"
              />
            </vs-tab>
            <vs-tab
              :disabled="roleAccount == 'user'"
              icon="people"
              label="User View"
            >
              <!-- <UserView :workerlist="workerlist"  :users2="users2" :attributes="attributes" :tempdata="tempdata" :selectedWO="selectedWO" :workerwork="workerwork" :users="users" :header="header"/> -->
              <UserView
                :tempdata="tempdata"
                :selectedWO="selectedWO"
                :workerlist="workerlist"
                :workerwork="workerwork"
                :headerFilter="headerFilter"
                :users="users"
                :header="header"
                :role="roleAccount"
              />
            </vs-tab>
          </vs-tabs>
        </vs-card>
      </vs-col>
    </vs-row>

    <b-modal
      id="modal-newWork"
      ref="modal-newWork"
      size="xl"
      no-close-on-backdrop="false"
      hide-header-close
      centered
      header-close-label
    >
      <template #modal-title>
        <h5 style="color: #32c040">New Work Order</h5>
      </template>
      <pre>{{ newwork }}</pre>

      <vs-alert
        class="mb-3"
        v-if="errors.length"
        color="warning"
        icon="new_releases"
      >
        <span>Fields can not be <b>empty</b> please enter the data</span>
      </vs-alert>

      <div class="container">
        <vs-row class="mb-3">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span class="detail">Type</span>
              <vs-row class="mt-3 selectVS">
                <input
                  class="mr-1"
                  type="radio"
                  id="one"
                  value="false"
                  v-model="newwork.type"
                />
                <label class="mr-4" for="one">Unplanned</label>
                <input
                  class="mr-1"
                  type="radio"
                  id="two"
                  value="true"
                  v-model="newwork.type"
                />
                <label for="two">Planned</label></vs-row
              >
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span class="detail">WO Name</span>
              <vs-input
                class="selectVS mt-1"
                :warning="fillWarning.nameWo"
                v-model="newwork.nameWo"
              />
              <span class="detailError">{{ this.errorNameWo }}</span>
            </div>
          </vs-col>
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span class="detail">Priority</span>
              <vs-select
                :warning="fillWarning.priority"
                class="selectVS mt-1"
                v-model="newwork.priority"
              >
                <vs-select-item
                  :key="index"
                  :value="item.value"
                  :text="item.text"
                  v-for="(item, index) in optionsPriority"
                />
              </vs-select>
              <span class="detailError">{{ this.errorPriority }}</span>
            </div>
          </vs-col>
        </vs-row>
        <vs-row class="mb-3">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span id="warningAsset" class="detail">Location</span>
              <vs-select
                :warning="fillWarning.asset"
                class="selectVS mt-1"
                v-model="newwork.asset"
              >
                <vs-select-item
                  :key="index"
                  :value="item.text"
                  :text="item.text"
                  v-for="(item, index) in location"
                />
              </vs-select>
              <!-- <vs-input
                class="selectVS mt-1"
                :warning="fillWarning.asset"
                v-model="newwork.asset"
              /> -->
              <span class="detailError">{{ this.errorAsset }}</span>
            </div>
          </vs-col>
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span class="detail">Assignee</span>
              <vs-select
                :warning="fillWarning.nameWorker"
                class="selectVS mt-1"
                v-model="newwork.nameWorker"
              >
                <vs-select-item
                  :key="index"
                  :value="item.username"
                  :text="item.username"
                  v-for="(item, index) in workerlist"
                />
              </vs-select>
              <span class="detailError">{{ this.errorNameWorker }}</span>
            </div>
          </vs-col>
        </vs-row>
        <vs-row v-if="showStartDate == true" class="mb-3">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span class="detail">Due Date</span>
              <div class="selectVS mt-1">
                <!-- <VueCtkDateTimePicker
              position="bottom"
              onlyDate
              noHeader
              noLabel
              format="YYYY-MM-DD"
             v-model="newwork.duedate"
            >
              <button
                class="vs-select--input fontSizeData"
                style="background: white; width: 200px"
                type="button"
              
              ></button
            >
            </VueCtkDateTimePicker>
                <VueCtkDateTimePicker
                  position="bottom"
                  format="YYYY-MM-DD HH:mm:ss"
                  v-model="newwork.duedate"
                ><button
                class="vs-select--input fontSizeData"
                style="background: white; "
                type="button"
              ></button
            >
            </VueCtkDateTimePicker> -->
                <datetime
                  v-model="newwork.duedate"
                  format="yyyy-MM-dd HH:mm:ss"
                  style="border: none"
                  type="datetime"
                />
              </div>
              <span class="detailError">{{ this.errorDuedate }}</span>

              <!-- <p  class="mt-1 btnShowDate" @click="showStartDate = false" >Add Start Date</p> -->
              <div>
                <vs-button
                  class="rounded-pill"
                  size="small"
                  color="success"
                  @click="showStartDate = false"
                  type="flat"
                  >Add Start Date</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>

        <vs-row v-if="showStartDate == false" class="mb-3">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span class="detail">Start Date</span>

              <div class="selectVS mt-1">
                <datetime
                  format="yyyy-MM-dd HH:mm:ss"
                  v-model="newwork.plandate"
                  style="border: none"
                  type="datetime"
                />
                <!-- <datetime style="border-style:initial;" v-model="newwork.plandate" type="datetime" />
                <VueCtkDateTimePicker
                  position="bottom"
                  format="YYYY-MM-DD HH:mm:ss"
                  v-model="newwork.plandate"
                ><button
                class="vs-select--input fontSizeData"
                style="background: white; "
                type="button"
              
              ></button
            ></VueCtkDateTimePicker> -->
              </div>
            </div>
          </vs-col>
        </vs-row>
        <vs-row v-if="showStartDate == false" class="mb-3">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="6"
          >
            <div class="input-box container-fluid">
              <span class="detail">Due Date</span>
              <div class="selectVS mt-1">
                <datetime
                  format="yyyy-MM-dd HH:mm:ss"
                  v-model="newwork.duedate"
                  style="border: none"
                  type="datetime"
                />
                <!-- <datetime style="border-style:initial;" v-model="newwork.plandate" type="datetime" /> -->
                <!-- <VueCtkDateTimePicker
                  class="toggleA"
                  format="YYYY-MM-DD HH:mm:ss"
                  v-model="newwork.duedate"
                ><button
                class="vs-select--input fontSizeData"
                style="background: white; "
                type="button"
              
              ></button
            ></VueCtkDateTimePicker> -->
              </div>
              <span class="detailError">{{ this.errorDuedate }}</span>
              <!-- <p  class="mt-1 btnShowDate" @click="showStartDate = true" >Due Date Only</p> -->
              <div>
                <vs-button
                  class="mt-1 rounded-pill"
                  size="small"
                  color="success"
                  @click="showStartDate = true"
                  type="flat"
                  >Due Date Only</vs-button
                >
              </div>
            </div>
          </vs-col>
        </vs-row>

        <vs-row class="mb-3">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="12"
          >
            <div class="input-box container-fluid">
              <vs-row vs-align="center">
                <span class="detail mr-2">Upload File</span>
                <vs-button
                  style="border-radius: 20px"
                  icon="cloud_upload"
                  v-if="showUpload == false"
                  color="primary"
                  @click="showUpload = !showUpload"
                  type="filled"
                  >Select File</vs-button
                ></vs-row
              >
              <UploadImages
                v-if="showUpload == true"
                class="mt-2"
                style="padding: 5px"
                @changed="handleImages"
              />
              <!-- <pre>{{imageArray}}</pre> -->
            </div>
          </vs-col>
        </vs-row>

        <vs-row class="mb-4">
          <vs-col
            style="padding: 0px"
            vs-type="flex"
            vs-align="center"
            vs-w="12"
          >
            <div class="input-box container-fluid">
              <span class="detail">Instruction</span>
              <vs-textarea
                class="widthTextArea mt-1"
                v-model="newwork.instructions"
              />
              <!-- <vs-button
                icon="done"
                size="small"
                @click="complete"
                class="rounded-pill"
                color="success"
                type="filled"
                >Complete</vs-button
              > -->
            </div>
          </vs-col>
        </vs-row>
      </div>

      <template #modal-footer>
        <!-- modal second
         v-b-modal.modal-multi-3 -->
        <vs-button
          type="filled"
          size="sm"
          style="width: 80px; border-radius: 20px"
          @click="newWorkSent(newwork)"
          color="success"
          >Submit</vs-button
        >
        <vs-button
          class="brdbtn"
          color="dark"
          style="width: 80px; border-radius: 20px"
          type="flat"
          @click="cancel()"
          >Cancel</vs-button
        >
      </template>
    </b-modal>
    <b-modal id="modal-multi-3" size="lg" title="New Work Order" :ok="refresh">
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
          <vs-textarea
            label="Worker's Name"
            height="60px"
            v-model="newwork.nameWo"
            readonly
          />
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
          <vs-textarea
            label="Worker's Email"
            height="60px"
            v-model="newwork.nameWorker"
            readonly
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-textarea
            label="Type"
            height="60px"
            v-model="newwork.type"
            readonly
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
          <vs-textarea
            label="Start Date  :"
            height="60px"
            v-model="newwork.plandate"
            readonly
          />
        </vs-col>
        <vs-col vs-type="flex" vs-align="center" vs-lg="6" vs-sm="6" vs-xs="12">
          <vs-textarea
            label="Due Date  :"
            height="60px"
            v-model="newwork.duedate"
            readonly
          />
        </vs-col>
      </vs-row>
      <vs-row vs-w="12">
        <vs-col
          vs-type="flex"
          vs-align="center"
          vs-lg="12"
          vs-sm="12"
          vs-xs="12"
        >
          <vs-textarea
            label="priority"
            rows="3"
            v-model="newwork.priority"
            readonly
          />
        </vs-col>
      </vs-row>

      <template #modal-footer="{ cancel }">
        <vs-button
          type="filled"
          size="sm"
          style="border-radius: 20px"
          @click="refresh()"
          color="success"
          >Save Work Order</vs-button
        >

        <b-button
          class="ml-2 mr-4"
          id="btncancel"
          variant="light"
          @click="cancel()"
        >
          Cancel
        </b-button>
      </template>
    </b-modal>

    <WO v-if="showWork" :viewwork="viewwork" />
  </div>
</template>

<script>
import UploadImages from "vue-upload-drop-images";
import UserView from "../dashboard/Workorder/UserView.vue";
import WO from "../material/WorkView.vue";
import Workview from "../dashboard/Workorder/Workview.vue";
import CalendarView from "../dashboard/Workorder/CalendarView.vue";
export default {
  name: "WorkOrder",
  components: {
    WO,
    Workview,
    CalendarView,
    UserView,
    UploadImages,
  },
  data: () => ({
    location: [
      { text: "Location Test - 01"},
      { text: "Location Test - 02"},
      { text: "Location Test - 03"},
    ],
    showStartDate: true,
    showUpload: false,
    dataWOUser: [],
    viewpercentage: 0,
    header: [
      "Priority",
      "WO Name",
      "Location",
      "Assigned To",
      "Creator",
      "Start Date",
      "End Date",
      "Status",
      "Response",
      "Overdue",
    ],
    headerFilter: [
      "Priority",
      "WO Name",
      "Assigned To",
      "Type",
      "Asset",
      "Creator",
      "Start Date",
      "End Date",
      "Status",
      "Response",
      "Overdue",
    ],
    arrFilter: [
      "Priority",
      "WO ID",
      "WO Name",
      "Assigned To",
      "Creator",
      "Asset",
      "Start Date",
      "End Date",
      "Status",
    ],
    value1: "",
    value2: "",
    descriptionItems: [10, 20],
    selected1: [],
    selected2: 0,
    formData: null,
    formInputData: null,
    showWork: false,
    attributes: [
      {
        key: "today",
        highlight: true,
        dates: new Date(),
      },
      // {
      //   dot: {
      //     color: 'red',
      //   },
      //   dates: [
      //     new Date(2020, 9, 5)
      //   ]
      // }
    ],
    selected: [],
    getName: "",
    getWororderUser: [],
    ot: 0,
    selectFilter: [],
    options1: [{ text: "Name", value: "Name" }],
    options2: [
      { text: "Work Order", value: "Work Order" },
      { text: "Asset", value: "Asset" },
      { text: "Status", value: "Status" },
    ],
    options3: [{ text: "Clear Filter", value: "clear" }],
    lt: 3,
    odt: 0,
    ct: 0,
    ts: 0,
    og: 0,
    activePrompt: false,
    activePrompt2: false,
    // fillWarning: false,
    checker: "List",
    fillWarning: {
      nameWorker: false,
      asset: false,
      nameWo: false,
      woName: false,
      username: false,
      priority: false,
    },
    // newwork: {
    //   name: "",
    //   woName: "",
    //   detail: "",
    //   iscomplete: false,
    //   form: { formConfig: { headline: null } },
    //   email: "",
    //   timestamp: "",
    //   plandate: "",
    //   duedate: "",
    //   finishtime: "",
    //   username: "",
    //   priority: "",
    //   type: "",
    //   dueDate: "",
    // },
    newwork: {
      type: false,
      nameWo: "",
      iscomplete: false,
      priority: "",
      instructions: "",
      asset: "",
      nameWorker: "",
      email: "",
      duedate: "",
      plandate: "",
      timestamp: "",
      // response: "",
    },
    selectedday: null,
    formlist: [],
    show: false,
    workerlist: [],
    tempdata: [],
    tablename: "List Table",
    users: [],
    users2: [],
    workerwork: [],
    temp: null,
    viewwork: null,
    role: "",
    roleAccount: "",
    optionsPriority: [
      { text: "1 - Low Priority", value: 1 },
      { text: "2 - Medium Priority", value: 2 },
      { text: "3 - High Priority", value: 3 },
    ],
    filterPriority: [
      { text: "1 - Low Priority", value: 1 },
      { text: "2 - Medium Priority", value: 2 },
      { text: "3 - High Priority", value: 3 },
    ],
    filterResponse: [
      "Created",
      "Submitted",
      "Approved",
      "Rejected",
      "Acknowledged",
      "Cancelled",
      "Declined",
    ],
    filterActive: ["Open", "Closed"],
    filterAssignedTo: [],
    filterAssetUser: [],
    filterAssetAll: [],
    errors: [],
    errorAsset: "",
    errorNameWorker: "",
    errorDuedate: "",
    errorPriority: "",
    errorNameWo: "",
    activeClass: "active",
    errorClass: "text-danger",
    imageArray: [],
  }),
  methods: {
    successUpload(event) {
      //notify
      this.$vs.notify({ color: "success", title: "Upload Success" });

      //get the filePaths from Laravel controller
      let filePaths = event.currentTarget.response;
      console.log(event.currentTarget.responset);

      //do something with the file paths...
    },

    showModalComplete() {
      this.$refs["my-modalcom"].show();
    },
    savedetail() {
      this.$API
        .post("work/update", {
          inputdata: this.formInputData,
          editdate: this.$moment().format("YYYY-MM-DD HH:mm:ss"),
          id: this.viewwork.id,
        })
        .then(() => {
          location.reload();
        });
      this.activePrompt = false;
    },
    refresh() {
      location.reload();
    },
    showMsgBoxOne(item) {
      this.boxOne = "";
      this.$bvModal
        .msgBoxOk("Action completed", {
          title: "Work Detail",
          size: "xl",
          buttonSize: "sm",
          okVariant: "success",
          headerClass: "p-2 border-bottom-0",
          footerClass: "p-2 border-top-0",
          centered: true,
        })
        .then((value) => {
          this.boxOne = value;
        })
        .catch((err) => {
          // An error occurred
        });
    },
    showWorkOrder(item) {
      // console.log(item)
      this.viewwork = item;
      this.showWork = true;
    },
    filterchange(mode) {
      this.checker = mode;
      switch (mode) {
        case "User":
          this.tablename = "User Table";
          break;
        case "Calendar":
          this.users = [];
          this.tablename = "Work on this day";
          this.clicked(this.$moment().format("YYYY-MM-DD"), 2);
          break;
        case "List":
          this.users = this.tempdata;
          this.tablename = "List Table";
          break;
      }
    },
    clicked(item, mode) {
      // console.log(item)
      this.users2 = [];
      switch (mode) {
        case 1:
          this.tablename = "Work on " + item.ariaLabel;
          this.tempdata.forEach((element) => {
            if (
              this.$moment(element.plandate).format("YYYY-MM-DD") == item.id
            ) {
              this.users2.push(element);
            }
          });
          break;
        case 2:
          this.tempdata.forEach((element) => {
            if (this.$moment(element.plandate).format("YYYY-MM-DD") == item) {
              this.users2.push(element);
            }
          });
      }
    },
    actionchange(item, mode) {
      this.newwork.timestamp = this.$moment().format("YYYY-MM-DD HH:mm:ss");
      switch (mode) {
        case 1:
          this.newwork.name = item.username;
          this.newwork.email = item.email;
          break;
        case 2:
          this.newwork.form = item.conf;
          break;
      }
    },
    // validEmail(email) {
    //   var re =
    //     /^(([^<>()\[\]\\.,;:\s@"]+(\.[^<>()\[\]\\.,;:\s@"]+)*)|(".+"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;
    //   return re.test(email);
    // },
    handleImages(files) {
      this.imageArray = files;
      console.log(this.imageArray);
      /*
                  [
                    {
                        "name": "Screenshot from 2021-02-23 12-36-33.png",
                        "size": 319775,
                        "type": "image/png",
                        "lastModified": 1614080193596
                        ...
                    },
                    ...
                    ]
                 */
    },
    newWorkSent(e) {
      this.errorAsset = "";
      this.errorNameWorker = "";
      this.errorDuedate = "";
      this.errorPriority = "";
      this.errorNameWo = "";
      this.fillWarning.nameWo = false;
      this.fillWarning.nameWorker = false;
      this.fillWarning.asset = false;
      this.fillWarning.priority = false;
      console.log(e);
      this.errors = [];
      if (!e.nameWo || !e.nameWorker || !e.asset || !e.duedate || !e.priority) {
        this.$vs.notify({
          title: "Warning!",
          text: "Fields can not be empty please enter the data",
          color: "warning",
          position: "top-center",
        });
      }
      if (!e.nameWo) {
        this.errorNameWo = "Please enter a name.";
        this.fillWarning.nameWo = true;
        this.errors.push("Please enter a name for this Work Order.");
      }
      if (!e.nameWorker) {
        this.errorNameWorker = "Please select a user";
        this.fillWarning.nameWorker = true;
        this.errors.push("Please select a user");
      }
      if (!e.asset) {
        this.errorAsset = "Please enter asset.";
        this.fillWarning.asset = true;
        this.errors.push("Please select a duedate");
      }
      if (!e.duedate) {
        this.errors.push("Please select a duedate");
        this.errorDuedate = "Please select a duedate.";
      }
      if (!e.priority) {
        this.errorPriority = "Please select a priority";
        this.fillWarning.priority = true;
        this.errors.push("Please select a priority");
      }
      if (!this.errors.length) {
        // get name find e-mail
        this.workerlist.forEach((value) => {
          if (e.nameWorker == value.username) {
            console.log(value.email);
            e.email = value.email;
          }
        });
        console.log(e.email);
        // add timestamp
        e.timestamp = this.$moment().format("YYYY-MM-DD HH:mm:ss");
        this.$API
          .post("savework2", {
            headers: {
              "Access-Control-Request-Method": "*",
              "Access-Control-Request-Headers": "*",
              Origin: "*",
            },
            type: e.type,
            nameWo: e.nameWo,
            iscomplete: true,
            admin: this.$session.get("username"),
            priority: e.priority,
            instructions: e.instructions,
            asset: e.asset,
            nameWorker: e.nameWorker,
            email: e.email,
            timestamp: e.timestamp,
            duedate: e.duedate,
            plandate: e.plandate,
            response: "Created",
          })
          .then(() => {
            this.$refs["modal-newWork"].hide();
            this.$vs.notify({
              title: "Successfully",
              text: "Work Order successfully started",
              color: "success",
              position: "top-center",
            });

            setTimeout(() => {
              location.reload();
            }, 1000);
          })
          .catch(() => {
            this.$vs.notify({
              title: "Warning!",
              text: "Fields can not be empty please enter the data",
              color: "warning",
              position: "top-center",
            });
          });
        return true;
      }
    },

    cancel() {
      this.$refs["modal-newWork"].hide();
      this.newwork = [];
      this.errors = [];
      this.errorAsset = "";
      this.errorNameWorker = "";
      this.errorDuedate = "";
      this.errorPriority = "";
      this.errorNameWo = "";
      this.fillWarning.nameWo = false;
      this.fillWarning.nameWorker = false;
      this.fillWarning.asset = false;
      this.fillWarning.priority = false;
      this.showUpload = false;
    },
    copysent(item) {
      // console.log(item)
      Object.keys(item).forEach((element) => {
        if (item[element] == "-") item[element] = null;
      });
      var name = item.name + " - Copy";
      this.$API
        .post("work/save", {
          headers: {
            "Access-Control-Request-Method": "*",
            "Access-Control-Request-Headers": "*",
            Origin: "*",
          },
          name: name,
          detail: item.detail,
          iscomplete: false,
          form: item.form,
          email: item.email,
          timestamp: item.timestamp,
          duedate: item.duedate,
          plandate: item.plandate,
          finishtime: item.finishtime,
          username: this.$session.get("username"),
        })
        .then(() => {
          location.reload();
        });
    },
    handleSelected(tempdata) {
      // console.log("hellllll")
    },
    formating(item) {
      item.timespent =
        this.$moment(item.finishtime).diff(item.startdate, "hours") || 0;
      this.ts += item.timespent;
      item.timestamp = this.$moment(item.timestamp).format(
        "YYYY-MM-DD HH:mm"
      );
      item.startdate = this.$moment(item.startdate).format(
        "YYYY-MM-DD HH:mm"
      );
      item.finishtime = this.$moment(item.finishtime).format(
        "YYYY-MM-DD HH:mm"
      );
      item.plandate = this.$moment(item.plandate).format("YYYY-MM-DD HH:mm");
      item.duedate = this.$moment(item.duedate).format("YYYY-MM-DD HH:mm");
      item.editdate = this.$moment(item.editdate).format("YYYY-MM-DD HH:mm");
      if (item.type == false) item.type = "Unplanned";
      if (item.type == true) item.type = "Planned";
      if (item.iscomplete == false) item.iscomplete = "Open";
      if (item.iscomplete == true) item.iscomplete = "Closed";
      if (item.response == 1) item.response = "Created";
      if (item.response == 2) item.response = "Submitted";
      if (item.response == 3) item.response = "Approved";
      if (item.response == 4) item.response = "Rejected";
      if (item.response == 5) item.response = "Acknowledged";
      if (item.response == 6) item.response = "Declined";
      if (item.response == 7) item.response = "Cancelled";
      if (item.priority == 1) item.priority = "1 - Low priority";
      if (item.priority == 2) item.priority = "2 - Medium priority";
      if (item.priority == 3) item.priority = "3 - High priority";
      if (item.overdue == false) item.overdue = "On Time";
      if (item.overdue == true) item.overdue = "Overdue";

      // Object.keys(item).forEach((element) => {
      //   if (
      //     (element.match("date") || element.match("time")) &&
      //     element.match("plandate") &&
      //     element.match("spent")
      //   ) {
      //     item[element] = this.$moment(item[element])
      //       .subtract(7, "hours")
      //       .format("YYYY-MM-DD HH:mm:ss");
      //   }
      // });
      // if (item.iscomplete == true) {
      //   item.iscomplete = "Complete";
      //   this.ct += 1;
      // } else {
      //   if (item.startdate == "Invalid date") item.startdate = "-";
      //   if (item.plandate == "Invalid date") item.plandate = "-";
      //   item.finishtime = this.$moment(item.finishtime).format(
      //     "YYYY-MM-DD HH:mm:ss"
      //   );
      //   if (item.finishtime == "Invalid date") item.finishtime = "-";
      //   if (item.editdate == "Invalid date") item.editdate = "-";
      //   if (!item.timespent) {
      //     item.iscomplete = "Upcoming";
      //     this.ot += 1;
      //   } else {
      //     item.iscomplete = "Complete";
      //     this.ct += 1;
      //   }
      //   if (item.startdate != "-" && item.finishtime == "-") {
      //     item.iscomplete = "Open";
      //     this.og += 1;
      //     this.ot -= 1;
      //   }
      //   if (
      //     item.startdate == "-" &&
      //     this.$moment(this.$moment().format("YYYY-MM-DD")).isAfter(
      //       item.plandate
      //     )
      //   ) {
      //     this.lt += 1;
      //     if (item.iscomplete == "Upcoming") this.ot -= 1;
      //     else if (item.iscomplete == "Open") this.og -= 1;
      //     item.state = "warning";
      //     item.iscomplete += " (Late)";
      //   }
      //   if (
      //     item.finishtime == "-" &&
      //     this.$moment(this.$moment().format("YYYY-MM-DD")).isAfter(
      //       item.duedate
      //     )
      //   ) {
      //     this.odt += 1;
      //     if (item.iscomplete == "Upcoming") this.ot -= 1;
      //     else if (item.iscomplete == "Open") this.og -= 1;
      //     item.state = "danger";
      //     item.iscomplete += " (Overdue)";
      //   }
      // }
      return item;
    },
  },
  mounted() {
    this.role = this.$session.get("role");
    this.roleAccount = this.$session.get("role");
    console.log(this.role);
    this.username = this.$session.get("username");
    switch (this.role) {
      case "admin":
        this.$API.get("account/user").then((result) => {
          this.workerlist = result.data;
          // console.log(this.workerlist);
          this.workerlist.forEach((element) => {
            this.workerwork.push({ name: element.name, list: [] });
            this.filterAssignedTo.push(element.username);
          });
          this.filterAssignedTo = new Set(this.filterAssignedTo);
          console.log(this.workerwork);
          this.$API.get("getform/user").then((result) => {
            this.formlist = result.data;
            this.$API.get("work").then((result) => {
              console.log(result);
              this.users = result.data;
              this.tempdata = this.users.map((element) =>
                this.formating(element)
              );

              // getResponse
              this.tempdata.forEach((elTemp) => {
                // console.log(element.id);
                this.$API.get(`work/${elTemp.id}/log`).then((result) => {
                  // console.log(result.data);
                  result.data.forEach((element) => {
                    // console.log(element.response)
                    if (
                      element.response == "created" ||
                      element.response == "Created"
                    ) {
                      Object.assign(elTemp, { createdRes: element });
                    } else if (element.response == "Acknowledged") {
                      Object.assign(elTemp, { acknowledgedRes: element });
                    } else if (element.response == "Submitted") {
                      Object.assign(elTemp, { submittedRes: element });
                    } else if (element.response == "Approved") {
                      Object.assign(elTemp, { approvedRes: element });
                    } else if (element.response == "Cancelled") {
                      Object.assign(elTemp, { cancelledRes: element });
                    } else if (element.response == "Rejected") {
                      Object.assign(elTemp, { rejectedRes: element });
                    } else if (element.response == "Declined") {
                      Object.assign(elTemp, { declinedRes: element });
                    }
                  });
                });
              });

              this.$API.get(`work/390/log`).then((result) => {
                console.log(result);
              });

              console.log(this.tempdata);

              this.users.forEach((element) => {
                if (element.plandate) {
                  this.attributes.push({
                    highlight: "red",
                    dates: this.$moment(element.plandate)._d,
                  });
                }
                this.workerwork.forEach((el) => {
                  if (el.name == element.username) {
                    el.list.push(element);
                  }
                });
              });

              this.filterAssetUser = new Set(this.filterAssetUser);
              this.filterAssetAll = new Set(this.filterAssetAll);
            });
            // this.workerwork.forEach((el) => {
            //   if (el.name == element.username) {
            //     el.list.push(element);
            //   }
            // });
          });
          console.log(this.workerwork);
          this.users = this.users.map((element) => this.formating(element));
        });
        break;
      case "user":
        this.$API.get("account/user").then((result) => {
          this.workerlist = result.data;
          // console.log(this.workerlist);
          this.workerlist.forEach((element) => {
            this.workerwork.push({ name: element.name, list: [] });
            this.filterAssignedTo.push(element.username);
          });
          this.workerlist.forEach((element) => {
            if (this.username == element.username) {
              this.getName = element.username;
              console.log(this.getName);
            }
          });
          this.filterAssignedTo = new Set(this.filterAssignedTo);
          console.log(this.workerwork);
          this.$API.get("getform/user").then((result) => {
            this.formlist = result.data;
            this.$API.get("work/user").then((result) => {
              console.log(result.data);
              this.users = result.data;
              // this.tempdata = this.users.map((element) =>
              //   this.formating(element)
              // );
              result.data.forEach((el) => {
                if (this.getName == el.username) {
                  this.tempdata.push(el);
                  console.log(this.tempdata);
                  this.tempdata.map((element) => this.formating(element));
                }
                this.filterAssetAll.push(el.asset);
              });
              // getResponse
              this.tempdata.forEach((elTemp) => {
                // console.log(element.id);
                this.$API.get(`work/${elTemp.id}/log`).then((result) => {
                  // console.log(result.data);
                  result.data.forEach((element) => {
                    // console.log(element.response)
                    if (
                      element.response == "created" ||
                      element.response == "Created"
                    ) {
                      Object.assign(elTemp, { createdRes: element });
                    } else if (element.response == "Acknowledged") {
                      Object.assign(elTemp, { acknowledgedRes: element });
                    } else if (element.response == "Submitted") {
                      Object.assign(elTemp, { submittedRes: element });
                    } else if (element.response == "Approved") {
                      Object.assign(elTemp, { approvedRes: element });
                    } else if (element.response == "Cancelled") {
                      Object.assign(elTemp, { cancelledRes: element });
                    } else if (element.response == "Rejected") {
                      Object.assign(elTemp, { rejectedRes: element });
                    } else if (element.response == "Declined") {
                      Object.assign(elTemp, { declinedRes: element });
                    }
                  });
                });
              });

              this.tempdata.forEach((element) => {
                if (element.plandate) {
                  this.attributes.push({
                    highlight: "red",
                    dates: this.$moment(element.plandate)._d,
                  });
                }
                this.workerwork.forEach((el) => {
                  if (el.name == element.username) {
                    el.list.push(element);
                  }
                });
              });

              this.tempdata.forEach((el) => {
                // get Asset each user
                this.filterAssetUser.push(el.asset);
                console.log(this.filterAssetUser);
              });
              this.filterAssetUser = new Set(this.filterAssetUser);
              this.filterAssetAll = new Set(this.filterAssetAll);
            });
          });
          console.log(this.workerwork);
          this.users = this.users.map((element) => this.formating(element));
        });
        break;
      default:
        console.log("Try looking up for a hint.");
    }
    console.log(this.role);
  },
};
</script>
<style scoped>
.vs-dialog {
  max-height: 90%;
  overflow-y: auto;
  overflow-x: hidden;
}
input {
  border-radius: 0px;
}
button {
  border-radius: 0px;
}
.btn.btn-primary {
  border-radius: 0px;
}
.btn.btn-secondary {
  border-radius: 0px;
}
.btn.btn-warning {
  border-radius: 0px;
}
.btn.btn-danger {
  border-radius: 0px;
}
#center {
  display: flex;
  align-items: center;
}
.btn.btn-info {
  border-radius: 0px;
}
.list-group-item.list-group-item-action {
  border-radius: 0px;
}
.form-control {
  border-radius: 0px;
}
p.copyright-text {
  display: none;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
.vuesax-app-is-ltr .vs-input--input.hasIcon {
  padding-left: 32px;
  border-radius: 20px;
}
.vs-select--item.con-icon.activex {
  padding-left: 30px;
}
@media (max-width: 550px) {
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
th {
  padding: 0px;
}
.col-md-1.control-view-wrapper {
  padding-left: 1%;
}
.col-md-2.control-view-wrapper {
  padding-left: 1%;
}
.col-md-3.control-view-wrapper {
  padding-left: 1%;
}
.col-md-4.control-view-wrapper {
  padding-left: 1%;
}
.col-md-6.control-view-wrapper {
  padding-left: 1%;
}
.col-md-12.control-view-wrapper {
  padding-left: 1%;
}
.vs-divider-border.before.vs-divider-border-default {
  background-color: #6eda78;
}
</style>

<style scoped>
.detailError {
  font-size: 0.3rem;
  padding-left: 4%;
  color: #ff911e;
}
.btnShowDate {
  color: #32c040;
  font-size: 0.75rem;
  cursor: pointer;
}
.btnShowDate:hover {
  transform: translate(0, 4px);
}

.selectVS {
  width: 75%;
  font-size: 0.75rem;
}

.detail {
  margin-left: 5px;
  font-size: 0.75rem;
  font-weight: 100;
}
input.vdatetime-input {
  border: none;
  padding-left: 10%;
  border-bottom: 1px solid black;
}
#btncancel {
  background-color: #ffffff;
  border-radius: 0;
  border-color: #ffffff;
}
.con-vs-card >>> .vs-card--header >>> .Test {
  padding-bottom: 0%;
}

.con-vs-card >>> .vs-card--header {
  background: linear-gradient(45deg, #6eda78, #2ed8b6);
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.a >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(38, 192, 183), rgb(52, 211, 167));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.b >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(238, 122, 111), rgb(248, 178, 143));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.c >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(86, 135, 232), rgb(55, 185, 224));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.con-vs-card.d >>> .vs-card--header {
  background: linear-gradient(45deg, rgb(243, 126, 151), rgb(243, 126, 151));
  color: whitesmoke;
  border-radius: 15px 15px 1px 1px;
  padding: 5px;
}
.selectExample {
  margin: 10px;
}
.con-select-example {
  display: flex;
  align-items: center;
  justify-content: center;
  flex-wrap: wrap;
}
.con-select .vs-select {
  width: 100%;
}
@media (max-width: 550px) {
  .selectVS {
    width: 100%;
  }
  .con-select {
    flex-direction: column;
  }
  .con-select .vs-select {
    width: 100%;
  }
}
.vschip {
  font-size: 100%;
}
th {
  padding: 0px;
}
.con-vs-dialog >>> .vs-dialog {
  width: 50%;
  max-width: 1000px;
}

button#dropdown-1_BV_toggle_.btn.dropdown-toggle.btn-secondary {
  border-radius: 5px;
}
</style>
